import React, { Component } from 'react'
import Breadcumb from '../../components/Breadcumb/Breadcumb'
import TotalCustomers from './TotalCustomers'
import Grid from '@material-ui/core/Grid';
const BreadcrumbData = [
    {
        id: 1,
        page_title: "Dashboard",
        page_path: "/",
        icon: "tachometer",
    }
]
export default class Dashboard extends Component {
    render() {
        return (
            <>
                <Breadcumb items={BreadcrumbData} />
                <div className="page-wrapper pd20">
                    <Grid container spacing={3}>
                        <Grid item lg={3} sm={3}>
                            <TotalCustomers />
                        </Grid>
                        <Grid item lg={3} sm={3}>
                            <TotalCustomers />
                        </Grid>
                        <Grid item lg={3} sm={3}>
                            <TotalCustomers />
                        </Grid>
                        <Grid item lg={3} sm={3}>
                            <TotalCustomers />
                        </Grid>
                    </Grid>


                </div>
            </>

        )
    }
}
